export default __webpack_public_path__ + "static/media/solenn_champs-elysees.c0162311.jpg";